import React from 'react';

/** The one grid/list segmented control (§03/§09 chrome spec): bg-surface-2
 *  pill, 32px segments, active = surface fill + bold + --sh-1. Used by
 *  VideoSection's bar and every direct-card video surface (downloads,
 *  shortlist detail, share pages), so the switcher reads identically
 *  everywhere videos are listed. */

const gridIc = (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
);
const listIc = (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
    <path d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

interface ViewToggleProps {
  view: string;
  onViewChange: (view: string) => void;
  gridValue?: string;
  listValue?: string;
  gridLabel?: string;
  listLabel?: string;
}

export const ViewToggle = ({
  view,
  onViewChange,
  gridValue = 'grid',
  listValue = 'list',
  gridLabel = 'Grid',
  listLabel = 'List',
}: ViewToggleProps) => {
  const options = [
    { value: gridValue, label: gridLabel, icon: gridIc },
    { value: listValue, label: listLabel, icon: listIc },
  ];
  return (
    <span className="inline-flex items-center gap-[3px] p-[3px] rounded-[9px] bg-surface-2 shrink-0">
      {options.map((o) => {
        const active = view === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onViewChange(o.value)}
            className={`inline-flex items-center gap-[7px] h-8 px-3 rounded-[7px] transition-colors ${
              active ? 'bg-surface text-text-1 font-bold' : 'text-text-1'
            }`}
            style={{ fontSize: 12.5, boxShadow: active ? 'var(--sh-1)' : 'none' }}
          >
            {o.icon}
            {o.label}
          </button>
        );
      })}
    </span>
  );
};
